module.exports = __webpack_public_path__ + "img/CanadaDay2024Flyer.a0597080.jpg";